const brushlessFeaturesZh = {
  // 无刷冲击钻/扳手
  product_drill_001_feature_1_title: '180° 可旋转手柄设计',
  product_drill_001_feature_1_desc: '创新的旋转结构支持在枪型与直型间一键切换，灵活应对从开阔平面到狭小死角的各种作业环境。',
  product_drill_001_feature_2_title: 'USB Type-C 快速充电',
  product_drill_001_feature_2_desc: '采用主流 Type-C 接口，无需专属充电器，手机充电线即可随时为其补充动力，提升作业连续性。',
  product_drill_001_feature_3_title: '高精度扭矩与 LED 照明',
  product_drill_001_feature_3_desc: '提供 4.5Nm 的稳定扭矩与 250rpm 转速，配合内置 LED 工作灯，确保在暗处也能精准完成精细装配。',
  product_drill_001_feature_4_title: '800W 无刷高效',
  product_drill_001_feature_4_desc: '800W 无刷电机消除碳刷磨损，更大动力输出、更低发热、更长使用寿命。',
  product_drill_001_feature_5_title: 'CE/UL/GS 三重认证',
  product_drill_001_feature_5_desc: '通过 CE、UL 和 GS 三重安全认证，在全球建筑市场深受专业人士信赖。',

  product_id_001_feature_1_title: '180° 可旋转手柄设计',
  product_id_001_feature_1_desc: '创新的旋转结构支持在枪型与直型间一键切换，灵活应对从开阔平面到狭小死角的各种作业环境。',
  product_id_001_feature_2_title: 'USB Type-C 快速充电',
  product_id_001_feature_2_desc: '采用主流 Type-C 接口，无需专属充电器，手机充电线即可随时为其补充动力，提升作业连续性。',
  product_id_001_feature_3_title: '高精度扭矩与 LED 照明',
  product_id_001_feature_3_desc: '提供 4.5Nm 的稳定扭矩与 250rpm 转速，配合内置 LED 工作灯，确保在暗处也能精准完成精细装配。',
  product_id_001_feature_4_title: '800W 无刷高效',
  product_id_001_feature_4_desc: '800W 无刷电机消除碳刷磨损，更大动力输出、更低发热、更长使用寿命。',
  product_id_001_feature_5_title: 'CE/UL/GS 三重认证',
  product_id_001_feature_5_desc: '通过 CE、UL 和 GS 三重安全认证，在全球建筑市场深受专业人士信赖。',

  product_id_002_feature_1_title: '6 档智能速度调节',
  product_id_002_feature_1_desc: '具备 6 档调速功能，可根据精细维修或强力紧固的需求精准匹配速度。',
  product_id_002_feature_2_title: '双模操作与高扭矩',
  product_id_002_feature_2_desc: '电驱模式提供 5Nm 扭矩，手动模式最大可承受 8Nm 力量。',
  product_id_002_feature_3_title: '360° 无影照明',
  product_id_002_feature_3_desc: '内置 3 颗 LED 工作灯，确保在暗处作业时视线清晰无死角。',
  product_id_002_feature_4_title: '800W 峰值无刷输出',
  product_id_002_feature_4_desc: '800W 电机处理高难度钻孔任务，无刷设计确保更凉爽、更持久的运行。',
  product_id_002_feature_5_title: '305 mm 紧凑机身',
  product_id_002_feature_5_desc: '305 mm 的机身可进入墙腔和天花板空洞等狭窄空间，现场应用灵活多变。',

  product_id_003_feature_1_title: '顶负载无刷动力',
  product_id_003_feature_1_desc: '搭载工业级无刷电机，提供惊人的 100Nm 最大扭矩，轻松贯穿硬质材料。',
  product_id_003_feature_2_title: '专业级全金属夹头',
  product_id_003_feature_2_desc: '采用 13mm (1/2") 全金属无钥匙夹头，提供卓越的抓紧力与耐用性。',
  product_id_003_feature_3_title: '三模切换与双速控制',
  product_id_003_feature_3_desc: '配备三功能金属冲击变速箱，支持双速调节，完美平衡高转速与高扭矩需求。',
  product_id_003_feature_4_title: '全能作业配置',
  product_id_003_feature_4_desc: '具备高达26250bpm的冲击率，内置 LED 工作灯与电量显示，确保各种环境下的精准作业。',
  product_id_003_feature_5_title: '750W 持续冲击动力',
  product_id_003_feature_5_desc: '750W 无刷电机即使面对锈蚀或过紧紧固件，也能保持一致的冲击扭矩。',

  product_id_004_feature_1_title: '无刷电机与强劲扭矩',
  product_id_004_feature_1_desc: '搭载高效无刷电机，提供高达 40Nm 的最大扭矩，轻松应对各种钻孔与紧固任务。',
  product_id_004_feature_2_title: '三模金属冲击变速箱',
  product_id_004_feature_2_desc: '具备三功能金属冲击变速箱，支持双速调节，灵活切换作业模式。',
  product_id_004_feature_3_title: '精准掌控与便捷设计',
  product_id_004_feature_3_desc: '采用 10mm金属夹头，配有 LED 工作灯与电量显示，确保精准操作。',
  product_id_004_feature_4_title: '极致轻量化表现',
  product_id_004_feature_4_desc: '整机重量仅为 0.79kg，大幅减轻高强度作业下的手部负担。',
  product_id_004_feature_5_title: '750W 持续冲击动力',
  product_id_004_feature_5_desc: '750W 无刷电机即使面对锈蚀或过紧紧固件，也能保持一致的冲击扭矩。',

  product_id_005_feature_1_title: '高效无刷动力',
  product_id_005_feature_1_desc: '采用先进无刷电机技术，提供 60Nm 强劲扭矩，显著提升作业效率与工具寿命。',
  product_id_005_feature_2_title: '大规格全金属夹头',
  product_id_005_feature_2_desc: '配备 10-13mm (3/8"-1/2") 全金属无钥匙夹头，兼容多种钻头，紧固力更强。',
  product_id_005_feature_3_title: '三模金属变速箱',
  product_id_005_feature_3_desc: '具备三功能金属冲击变速箱并支持双速调节（最高 1800rpm），完美平衡精准钻孔与强力冲击。',
  product_id_005_feature_4_title: '轻巧平衡的设计',
  product_id_005_feature_4_desc: '整机重量仅为 0.85kg，人体工学设计配合内置 LED 灯，确保在复杂环境下也能轻松操作。',
  product_id_005_feature_5_title: '60 分钟充电快速翻转',
  product_id_005_feature_5_desc: '20V 2.0Ah 60 分钟即可充满，午餐时间补电，下午继续全力作业。',

  product_id_006_feature_1_title: '无刷电机与强劲扭矩',
  product_id_006_feature_1_desc: '搭载高效无刷电机，提供高达 40Nm 的最大扭矩，轻松应对各种钻孔与紧固任务。',
  product_id_006_feature_2_title: '三模金属冲击变速箱',
  product_id_006_feature_2_desc: '具备三功能金属冲击变速箱，支持双速调节，灵活切换作业模式。',
  product_id_006_feature_3_title: '精准掌控与便捷设计',
  product_id_006_feature_3_desc: '采用 10mm金属夹头，配有 LED 工作灯与电量显示，确保精准操作。',
  product_id_006_feature_4_title: '极致轻量化表现',
  product_id_006_feature_4_desc: '整机重量仅为 0.79kg，大幅减轻高强度作业下的手部负担。',
  product_id_006_feature_5_title: '750W 持续冲击动力',
  product_id_006_feature_5_desc: '750W 无刷电机即使面对锈蚀或过紧紧固件，也能保持一致的冲击扭矩。',

  product_id_007_feature_1_title: '32 mm 环形钻孔系统',
  product_id_007_feature_1_desc: '32 mm 环形钻头穿透钢板、角钢和结构截面，精准钻出整洁圆孔。',
  product_id_007_feature_2_title: '1000W 磁力钻动力',
  product_id_007_feature_2_desc: '1000W 电机为施工现场结构钢上的环形钻孔提供所需的持续扭矩。',
  product_id_007_feature_3_title: '0–600 RPM 受控金属切削',
  product_id_007_feature_3_desc: '最低 600 RPM 的最大速度确保环形钻头最佳性能，不过热切削刃。',
  product_id_007_feature_4_title: '4.0Ah 电池支持钢材钻孔',
  product_id_007_feature_4_desc: '4.0Ah 电池支持长时间结构钢钻孔作业，无动力衰减。',
  product_id_007_feature_5_title: '3.20 kg 重型钢材钻机身',
  product_id_007_feature_5_desc: '3.20 kg 重型机身提供结构钢钻孔时保持环形钻头同轴所需的稳定性。',

  product_id_008_feature_1_title: '82 mm 岩芯钻系统',
  product_id_008_feature_1_desc: '82 mm 岩芯钻头在混凝土墙、地板和结构楼板上为管道和线管钻出大径圆孔。',
  product_id_008_feature_2_title: '900W 岩芯切削电机',
  product_id_008_feature_2_desc: '900W 驱动岩芯钻头穿透钢筋混凝土，钻出整洁圆孔，不损伤周边结构。',
  product_id_008_feature_3_title: '0–800 RPM 岩芯钻速度',
  product_id_008_feature_3_desc: '800 RPM 最大速度确保岩芯钻头使用寿命并保持穿透厚混凝土楼板时的整洁切削。',
  product_id_008_feature_4_title: '2.50 kg 稳定岩芯钻',
  product_id_008_feature_4_desc: '2.50 kg 机身提供切穿钢筋楼板时保持岩芯钻头对准所需的质量和平衡。',
  product_id_008_feature_5_title: '4.0Ah 应对完整混凝土工程',
  product_id_008_feature_5_desc: '4.0Ah 电池单次充电可穿透多个 82 mm 混凝土孔，高效完成楼板穿透作业。',

  product_id_009_feature_1_title: '重型材料搅拌桨',
  product_id_009_feature_1_desc: '搅拌桨附件在最重 30 kg 的桶中混合混凝土、砂浆、灌浆料和粘合剂，毫不费力。',
  product_id_009_feature_2_title: '850W 搅拌电机',
  product_id_009_feature_2_desc: '850W 电机即使在厚重材料中也能保持稳定的搅拌速度，不卡顿不过热。',
  product_id_009_feature_3_title: '0–700 RPM 受控搅拌速度',
  product_id_009_feature_3_desc: '最大 700 RPM 变速将搅拌速度控制在喷溅阈值以下，施工现场整洁搅拌。',
  product_id_009_feature_4_title: 'D 型把手双手控制',
  product_id_009_feature_4_desc: 'D 型把手握持，在大桶中搅拌重型材料时实现安全双手控制。',
  product_id_009_feature_5_title: '4.0Ah 支持长时间搅拌',
  product_id_009_feature_5_desc: '4.0Ah 电池组在整个施工现场搅拌周期中持续满足桨叶搅拌的高安培需求。',

  // 无刷冲击起子机
  product_idr_001_feature_1_title: '巅峰级冲击动力',
  product_idr_001_feature_1_desc: '搭载高效无刷电机，爆发 160Nm 巅峰扭矩，轻松驱动超长螺丝和高强度紧固任务。',
  product_idr_001_feature_2_title: '三档精准扭矩调节',
  product_idr_001_feature_2_desc: '具备三档可调扭矩（40/130/160 Nm）和三档转速调节，确保在不同材质上作业的精准度。',
  product_idr_001_feature_3_title: '极速装卸设计',
  product_idr_001_feature_3_desc: '采用 6.35mm (1/4") 快插式夹头，支持单手快速更换批头，显著提升作业效率。',
  product_idr_001_feature_4_title: '轻巧平衡的工业设计',
  product_idr_001_feature_4_desc: '仅 0.79kg 的超轻重量配合紧凑机身，即使在狭窄空间或高处作业也能掌控自如。',
  product_idr_001_feature_5_title: '700W 无刷冲击电机',
  product_idr_001_feature_5_desc: '700W 无刷电机在全天使用中每发提供高冲击能量，同时最大化电池效率。',

  product_idr_002_feature_1_title: '强劲冲击动力',
  product_idr_002_feature_1_desc: '具备 150Nm 的最大扭矩，能够轻松应对建筑装修及木工中的高强度紧固任务。',
  product_idr_002_feature_2_title: '极速作业表现',
  product_idr_002_feature_2_desc: '拥有 3000 rpm 的高转速与 3200 bpm 的冲击率，显著缩短长螺丝的驱动时间。',
  product_idr_002_feature_3_title: '便捷快插系统',
  product_idr_002_feature_3_desc: '配备 6.35mm (1/4") 快插夹头，支持单手快速更换批头，提升多任务切换效率。',
  product_idr_002_feature_4_title: '人性化作业辅助',
  product_idr_002_feature_4_desc: '机身紧凑且仅重 0.79kg，配合内置 LED 工作灯，确保在狭窄或昏暗环境下也能轻松操作。',
  product_idr_002_feature_5_title: '680W 高效驱动动力',
  product_idr_002_feature_5_desc: '680W 高效无刷电机最大化电池续航，每次充电完成更多螺钉驱动。',

  product_idr_003_feature_1_title: '巅峰级工业动力',
  product_idr_003_feature_1_desc: '搭载高性能无刷电机，提供高达 280Nm 的巅峰扭矩，专为超高强度紧固与重型工程打造。',
  product_idr_003_feature_2_title: '三档智能扭矩调节',
  product_idr_003_feature_2_desc: '具备三档可调扭矩（130/200/280 Nm）与三档变速系统，精准掌控不同材质的作业力度。',
  product_idr_003_feature_3_title: '极致作业效率',
  product_idr_003_feature_3_desc: '拥有高达 3200bpm 的冲击率与 2650rpm 的转速，配合快插夹头实现极速装配体验。',
  product_idr_003_feature_4_title: '紧凑型强力结构',
  product_idr_003_feature_4_desc: '仅 1.2kg 的机身重量实现了极高的功率重量比，内置 LED 灯确保复杂环境下的精准操控。',
  product_idr_003_feature_5_title: '多模式扭矩选择',
  product_idr_003_feature_5_desc: '多种扭矩模式设定，可在组装、紧固和结构模式之间切换，适应不同材料。',

  product_idr_004_feature_1_title: '巅峰工业级扭矩',
  product_idr_004_feature_1_desc: '搭载高性能无刷电机，提供高达 500Nm 的超强扭矩，专为重型机械紧固与汽车维修设计。',
  product_idr_004_feature_2_title: '专业级 1/2" 方头夹头',
  product_idr_004_feature_2_desc: '采用 12.7mm (1/2") 专业方头夹头，确保套筒装配稳固，在高强度冲击下依然坚固耐用。',
  product_idr_004_feature_3_title: '反转自停智能技术',
  product_idr_004_feature_3_desc: '具备反转自动停止功能，有效防止在拆卸螺母时因惯性导致螺母掉落或损坏。',
  product_idr_004_feature_4_title: '三档冲击与双速控制',
  product_idr_004_feature_4_desc: '提供最高 3200bpm 的冲击率与双速调节（最高 2650rpm），灵活匹配不同工况的需求。',
  product_idr_004_feature_5_title: '极致轻量化结构',
  product_idr_004_feature_5_desc: '整机重量仅为 1.2kg，在实现高功率输出的同时兼顾了操控的灵活性，有效减轻长时间作业的疲劳感。',

  product_idr_005_feature_1_title: '震慑级的工业扭矩',
  product_idr_005_feature_1_desc: '搭载巅峰性能的无刷电机，爆发 850Nm 的超强扭矩，专为重型工程、大型机械及卡车维修等极端紧固任务设计。',
  product_idr_005_feature_2_title: '专业级 1/2" 重型方头夹头',
  product_idr_005_feature_2_desc: '采用 12.7mm (1/2") 工业级方头夹头，在高频率冲击下依然稳固耐用，确保套筒装配安全可靠。',
  product_idr_005_feature_3_title: '反转自停智能保护',
  product_idr_005_feature_3_desc: '具备智能反转自停功能，在螺母松开后立即停止旋转，有效防止螺母意外飞脱或损坏作业面。',
  product_idr_005_feature_4_title: '多档智控调速系统',
  product_idr_005_feature_4_desc: '支持三档冲击频率（最高 2200bpm）与三档转速调节（最高 2400rpm），精准适配各种严苛作业场景。',
  product_idr_005_feature_5_title: '全天候作业性能',
  product_idr_005_feature_5_desc: '内置 LED 工作灯确保昏暗环境下的视野，结合 1.9kg 的强悍机身，在提供稳定动力的同时确保长寿命表现',

  product_idr_006_feature_1_title: '直角 165 N·m 冲击起子',
  product_idr_006_feature_1_desc: '直角头在狭窄空间输出 165 N·m 冲击扭矩，触达面板后方和橱柜内部的紧固件。',
  product_idr_006_feature_2_title: '0–2800 RPM 直角驱动',
  product_idr_006_feature_2_desc: '直角构型中 2800 RPM 变速，穿过墙体框架、地板和狭窄格栅驱动螺钉。',
  product_idr_006_feature_3_title: '258 mm 直角机身长度',
  product_idr_006_feature_3_desc: '258 mm 直角机身进入立柱格栅和橱柜内部，标准直线冲击起子无法触及。',
  product_idr_006_feature_4_title: '690W 直角电机',
  product_idr_006_feature_4_desc: '直角构型中的 690W 无刷电机为给排水、电气和框架施工提供可靠扭矩。',
  product_idr_006_feature_5_title: '旋转头多角度可达性',
  product_idr_006_feature_5_desc: '旋转头锁定在多个角度，可触达直线起子无法到达的紧固件位置。',

  product_idr_007_feature_1_title: '180 N·m 延伸体起子',
  product_idr_007_feature_1_desc: '延伸体构型的 180 N·m 冲击起子，非常适合触达深凹槽和长距离施工的紧固件。',
  product_idr_007_feature_2_title: '0–3200 RPM 延伸驱动',
  product_idr_007_feature_2_desc: '245 mm 延伸体中的全速 3200 RPM，快速精准将长螺钉驱入深层材料叠合处。',
  product_idr_007_feature_3_title: '245 mm 延伸机身',
  product_idr_007_feature_3_desc: '较长的 245 mm 机身触达高架脚手板、深层框架和难以到达的结构点上的紧固件。',
  product_idr_007_feature_4_title: '1.50 kg 稳定驱动重量',
  product_idr_007_feature_4_desc: '1.50 kg 均衡重量在伸展位置施工时帮助保持驱动精准。',
  product_idr_007_feature_5_title: '700W 长距离无刷电机',
  product_idr_007_feature_5_desc: '无刷 700W 电机在延伸体螺钉驱动中无有刷设计的发热积累问题。',

  product_idr_008_feature_1_title: '185 N·m 紧凑专业起子',
  product_idr_008_feature_1_desc: '172 mm 紧凑机身中的 185 N·m 冲击扭矩，专业应用中最大扭矩最小尺寸。',
  product_idr_008_feature_2_title: '0–3300 RPM 接近最高速',
  product_idr_008_feature_2_desc: '3300 RPM 接近最高速，结合高输出扭矩和速度，实现最快的专业螺钉驱动。',
  product_idr_008_feature_3_title: '1.35 kg 高扭矩紧凑型',
  product_idr_008_feature_3_desc: '1.35 kg 机身中的 185 N·m，是冲击起子系列最佳功重比。',
  product_idr_008_feature_4_title: '710W 高密度无刷电机',
  product_idr_008_feature_4_desc: '710W 电机高密度封装在紧凑外壳中，在出人意料的小工具内展现卓越性能。',
  product_idr_008_feature_5_title: '快换六角卡盘系统',
  product_idr_008_feature_5_desc: '磁力快换卡盘瞬间换头无需松开锁紧套，多紧固件作业效率大幅提升。',

  product_idr_009_feature_1_title: '170 N·m 顺滑静音起子',
  product_idr_009_feature_1_desc: '170 N·m 冲击扭矩配合全系最低噪音 ≤80 dB，室内精装和住宅工地的完美选择。',
  product_idr_009_feature_2_title: '超静音 80 dB 运行',
  product_idr_009_feature_2_desc: '最佳 ≤80 dB 噪音水平，非常适合室内精装环境、公寓楼和对噪音敏感的工作场所。',
  product_idr_009_feature_3_title: '0–3000 RPM 静音变速',
  product_idr_009_feature_3_desc: '全速 3000 RPM 变速同时保持最低噪音输出，室内精装的静音动力。',
  product_idr_009_feature_4_title: '680W 低噪无刷电机',
  product_idr_009_feature_4_desc: '无刷电机设计本质上比有刷替代品噪音和振动更小，作业更静音。',
  product_idr_009_feature_5_title: '软启动精细紧固',
  product_idr_009_feature_5_desc: '软启动功能防止在小螺钉和精细表面上打滑，非常适合精装木工和橱柜制作。',

  product_idr_010_feature_1_title: '220 N·m 最大扭矩起子',
  product_idr_010_feature_1_desc: '220 N·m 是冲击起子系列最高扭矩，应对最大结构六角螺栓和木螺钉。',
  product_idr_010_feature_2_title: '0–3500 RPM 顶速起子',
  product_idr_010_feature_2_desc: '最大 3500 RPM 配合 220 N·m，提供结构施工无与伦比的速度和扭矩组合。',
  product_idr_010_feature_3_title: '4.0Ah 电池支持重型紧固',
  product_idr_010_feature_3_desc: '4.0Ah 电池单次充电支持数百次结构六角螺栓循环，延长框架施工时间。',
  product_idr_010_feature_4_title: '800W 高输出无刷电机',
  product_idr_010_feature_4_desc: '800W 无刷电机是起子系列最高功率，在持续六角螺栓驱动中维持峰值扭矩。',
  product_idr_010_feature_5_title: '55 分钟 4.0Ah 快充',
  product_idr_010_feature_5_desc: '即使是大容量 4.0Ah 电池，仅需 55 分钟即可充满，持续推进结构施工。',

  // 无刷角磨机
  product_ag_001_feature_1_title: '高性能无刷动力系统',
  product_ag_001_feature_1_desc: '搭载新一代无刷电机，提供 8500 rpm 稳定高转速。相比有刷电机，能耗降低 30% 且寿命延长 2 倍，确保在连续重载切割作业中动力不掉速。',
  product_ag_001_feature_2_title: '全规格磨盘兼容性',
  product_ag_001_feature_2_desc: '兼容 Ø100-125mm 多种规格磨盘，并支持 M10-M14 及 5/8"-11UNC 国际标准螺纹，无需繁琐转接即可匹配市面主流耗材。',
  product_ag_001_feature_3_title: '精密深度调节与工业防护',
  product_ag_001_feature_3_desc: '具备 0-25mm 切割深度可调功能，配合高强度加厚全金属安全防护罩，在实现精准作业深度的同时，为用户提供顶级的防迸溅保护。',
  product_ag_001_feature_4_title: '极致平衡的人体工学设计',
  product_ag_001_feature_4_desc: ' 1.5kg 极致轻量化机身，经过重心平衡优化，显著降低长时间作业的手部疲劳感，窄型手柄设计提供更稳固的抓握力。',
  product_ag_001_feature_5_title: '防夹片过载保护',
  product_ag_001_feature_5_desc: '电子过载保护检测夹片并停止磨片，防止金属作业中的危险反弹。',

  product_ag_002_feature_1_title: '125 mm 标准磨片',
  product_ag_002_feature_1_desc: '125 mm 磨片是市面上最广泛的尺寸，兼容大量研磨、切割和打磨磨片。',
  product_ag_002_feature_2_title: '8500 RPM 专业研磨速度',
  product_ag_002_feature_2_desc: '8500 RPM 是 125 mm 磨片的最优研磨速度，平衡材料去除率和磨片寿命。',
  product_ag_002_feature_3_title: '900W 高输出电机',
  product_ag_002_feature_3_desc: '900W 电机在结构钢上进行长时间研磨作业时不过热或损失切割速度。',
  product_ag_002_feature_4_title: '4.0Ah 持续电源',
  product_ag_002_feature_4_desc: '4.0Ah 电池延长研磨和切割运行时间，减少与小容量电池频繁换电的问题。',
  product_ag_002_feature_5_title: '可调侧把手',
  product_ag_002_feature_5_desc: '可重新定位的侧把手让您为所有研磨姿势设置最佳握持角度，舒适控制。',

  product_ag_003_feature_1_title: '150 mm 重型研磨机',
  product_ag_003_feature_1_desc: '较大的 150 mm 磨片提供更大研磨表面积，在平整焊缝和大型钢截面上更快去料。',
  product_ag_003_feature_2_title: '8000 RPM 受控大磨片速度',
  product_ag_003_feature_2_desc: '8000 RPM 针对 150 mm 磨片尺寸优化，在安全周速内最大化研磨动力。',
  product_ag_003_feature_3_title: '1000W 最大功率电机',
  product_ag_003_feature_3_desc: '1000W 电机是研磨机系列最高功率，驱动 150 mm 磨片穿透重型钢板和厚焊缝。',
  product_ag_003_feature_4_title: '2.10 kg 磨机均衡重量',
  product_ag_003_feature_4_desc: '2.10 kg 机身提供在大面积平整表面上保持稳定磨片接触所需的质量。',
  product_ag_003_feature_5_title: '减振侧把手',
  product_ag_003_feature_5_desc: '减振侧把手降低研磨疲劳，提升重型去料施工的控制精度。',

  product_ag_004_feature_1_title: '125 mm 变速研磨机',
  product_ag_004_feature_1_desc: '从 4500 到 9500 RPM 变速，同一工具可激进研磨或精细收尾，无需换片。',
  product_ag_004_feature_2_title: '4500–9500 RPM 速度旋钮',
  product_ag_004_feature_2_desc: '速度旋钮精确匹配磨片速度与材料，不锈钢抛光用慢速，碳钢研磨用快速。',
  product_ag_004_feature_3_title: '变速无刷电机',
  product_ag_004_feature_3_desc: '无刷电机电子控制在变化负载下保持设定速度，在各种材料上实现一致表面。',
  product_ag_004_feature_4_title: '软启动保护磨片',
  product_ag_004_feature_4_desc: '软启动防止磨片启动冲击载荷，延长磨片寿命并提高研磨机耐久性。',
  product_ag_004_feature_5_title: '4.0Ah 支持变速作业',
  product_ag_004_feature_5_desc: '4.0Ah 电池支持研磨、切割和抛光的长时间变速作业，无需频繁换电。',

  product_ag_005_feature_1_title: '125 mm 不锈钢研磨机',
  product_ag_005_feature_1_desc: '针对 125 mm 不锈钢研磨和收尾优化，不污染材料即可实现整洁表面。',
  product_ag_005_feature_2_title: '8500 RPM 不锈钢安全速度',
  product_ag_005_feature_2_desc: '8500 RPM 配合受控动力输出，研磨对热敏感的不锈钢时防止过热。',
  product_ag_005_feature_3_title: '900W 稳定不锈钢性能',
  product_ag_005_feature_3_desc: '900W 持续电机输出在整个不锈钢板厚度上保持一致的研磨速度。',
  product_ag_005_feature_4_title: '防污染设计',
  product_ag_005_feature_4_desc: '内部组件密封防止不锈钢颗粒进入，保护电机和轴承不受污染。',
  product_ag_005_feature_5_title: '快换防护罩系统',
  product_ag_005_feature_5_desc: '无需工具即可快速调整防护罩，在研磨、切割和抛光磨片构型之间快速切换。',

  product_ag_006_feature_1_title: '125 mm 铝材抛光研磨机',
  product_ag_006_feature_1_desc: '专为 125 mm 铝材研磨和抛光调整，保持表面质量，不拖刮软铝材料。',
  product_ag_006_feature_2_title: '8500 RPM 铝材优化速度',
  product_ag_006_feature_2_desc: '8500 RPM 是铝材打磨片的理想速度，提供顺滑收尾效果，磨片上不积料。',
  product_ag_006_feature_3_title: '91 dB 低噪音特性',
  product_ag_006_feature_3_desc: '运行噪音 ≤91 dB，比大多数 125 mm 研磨机更安静，适合噪音管控更严的工坊。',
  product_ag_006_feature_4_title: '900W 铝材驱动电机',
  product_ag_006_feature_4_desc: '900W 电机高效研磨铝材，不产生使工件软化的过热。',
  product_ag_006_feature_5_title: '1.88 kg 均衡机身',
  product_ag_006_feature_5_desc: '1.88 kg 提供精度比原始动力更重要的受控铝材表面收尾的理想质量。',

  product_ag_007_feature_1_title: '125 mm 瓷砖切割研磨机',
  product_ag_007_feature_1_desc: '针对 125 mm 金刚石切割陶瓷砖、瓷砖和石材配置，边缘整洁无崩口。',
  product_ag_007_feature_2_title: '8500 RPM 瓷砖切割速度',
  product_ag_007_feature_2_desc: '8500 RPM 提供高效金刚石片瓷砖切割所需的线速度，边缘不崩口。',
  product_ag_007_feature_3_title: '900W 持续切割动力',
  product_ag_007_feature_3_desc: '900W 持续电机在厚瓷砖中保持切割速度，不让更低档研磨机卡顿。',
  product_ag_007_feature_4_title: '1.92 kg 稳定瓷砖切割重量',
  product_ag_007_feature_4_desc: '1.92 kg 机身为引导瓷砖切割提供稳定性，确保沿标记线的笔直精准切割。',
  product_ag_007_feature_5_title: '防尘密封电机应对瓷砖粉尘',
  product_ag_007_feature_5_desc: '密封电机内部防御瓷砖切割粉尘，延长切割石材和瓷砖时的工具使用寿命。',

  product_ag_008_feature_1_title: '125 mm 混凝土切割研磨机',
  product_ag_008_feature_1_desc: '专为 125 mm 混凝土切割和表面研磨设计，精准去除浮浆、高点和接缝密封剂。',
  product_ag_008_feature_2_title: '8500 RPM 混凝土磨片速度',
  product_ag_008_feature_2_desc: '8500 RPM 为 125 mm 混凝土切割和表面处理砂轮提供最优磨片速度。',
  product_ag_008_feature_3_title: '900W 混凝土级动力',
  product_ag_008_feature_3_desc: '900W 在切割致密混凝土截面和去除厚表面涂层时保持研磨速度。',
  product_ag_008_feature_4_title: '92 dB 高强度噪音水平',
  product_ag_008_feature_4_desc: '≤92 dB 噪音水平对于混凝土研磨机是典型值，工地上请按要求佩戴耳保护。',
  product_ag_008_feature_5_title: '4.0Ah 楼板作业',
  product_ag_008_feature_5_desc: '4.0Ah 电池在大型楼板截面混凝土研磨中持续供电，无需频繁充电。',

  product_ag_009_feature_1_title: '125 mm 变速抛光机',
  product_ag_009_feature_1_desc: '125 mm 抛光片 5000–8500 RPM 变速，精准速度控制实现无旋痕漆面修正和美容。',
  product_ag_009_feature_2_title: '5000–8500 RPM 抛光速度范围',
  product_ag_009_feature_2_desc: '从 5000 RPM 起步的较低速度范围，防止车漆和清漆层抛光过热烧伤。',
  product_ag_009_feature_3_title: '800W 无刷抛光电机',
  product_ag_009_feature_3_desc: '800W 无刷电机在抛光片压力下保持恒速，确保统一的收尾质量。',
  product_ag_009_feature_4_title: '1.85 kg 抛光均衡',
  product_ag_009_feature_4_desc: '1.85 kg 抛光机重量为漆面修正提供正确的接触压力，不会压力过大。',
  product_ag_009_feature_5_title: '电子速度稳定',
  product_ag_009_feature_5_desc: '电子调速器在片面阻力下稳定磨片速度，在各面板上保持一致表面收尾。',

  product_ag_010_feature_1_title: '125 mm 专业加工研磨机',
  product_ag_010_feature_1_desc: '金属加工的旗舰 125 mm 研磨机，研磨、切割、钢丝刷和表面处理同样出色。',
  product_ag_010_feature_2_title: '8500 RPM 全性能速度',
  product_ag_010_feature_2_desc: '所有磨片类型均达到 8500 RPM 一致速度，在加工工坊环境提供一致的专业性能。',
  product_ag_010_feature_3_title: '900W 加工级电机',
  product_ag_010_feature_3_desc: '900W 无刷电机应对加工施工的多样需求，从激进焊缝研磨到精细表面收尾。',
  product_ag_010_feature_4_title: '2.00 kg 均衡加工重量',
  product_ag_010_feature_4_desc: '2.00 kg 在受控精度施工和重型去料所需质量之间取得理想平衡。',
  product_ag_010_feature_5_title: '电子过载保护',
  product_ag_010_feature_5_desc: '电子保护监控电机负载并调整动力，防止高强度使用中的卡顿和热过载。',
  // ===== 无刷工具配件翻译 =====

  // 无刷钻/冲击钻系列配件（drill 类，共用）
  // brushless_drill_acc_1_name: '数据线',
  // brushless_drill_acc_1_desc: 'Tyep-C数据线',
  // brushless_drill_acc_2_name: '快充充电器',
  // brushless_drill_acc_2_desc: '55 分钟可将 4Ah 电池充满，午饭时间充电，下午继续满功率作业，停工时间最短',
  // brushless_drill_acc_3_name: 'HSS 钻头套装',
  // brushless_drill_acc_3_desc: '1–13 mm 共 19 支 HSS 钻头套装，兼容木材、金属和塑料，覆盖日常全部钻孔需求',
  // brushless_drill_acc_4_name: '混凝土锚固钻头组',
  // brushless_drill_acc_4_desc: '6/8/10/12 mm SDS+ 或直柄混凝土钻头组，专为冲击模式下的墙体锚固钻孔优化',
  // brushless_drill_acc_5_name: '工具收纳箱',
  // brushless_drill_acc_5_desc: '泡沫内衬硬壳收纳箱，专为钻机、电池和配件量身定制，现场存储和携带安全可靠',
  // brushless_drill_acc_6_name: '防护目镜',
  // brushless_drill_acc_6_desc: '透明防雾镜片安全防护目镜，抵御钻孔时飞溅的混凝土碎屑和金属切屑',
  // brushless_drill_acc_7_name: '清洁保养套装',
  // brushless_drill_acc_7_desc: '含清洁刷、润滑脂和擦拭布的综合保养套装，保持卡盘顺滑运转，延长工具使用寿命',
  // brushless_drill_acc_8_name: '侧手柄',
  // brushless_drill_acc_8_desc: '可调节侧手柄，大扭矩作业时提供双手稳定控制，降低反转风险，提高钻孔精度',

  // 无刷冲击起子机系列配件（idr 类，共用）
  // brushless_idr_acc_1_name: '20V 4Ah 锂电池',
  // brushless_idr_acc_1_desc: '大容量 20V 4Ah 锂电池，全天结构紧固作业使用，单次充电可完成数百颗螺钉驱入',
  // brushless_idr_acc_2_name: '快充充电器',
  // brushless_idr_acc_2_desc: '55 分钟急速充电器，4Ah 大容量电池快速补电，高强度施工无等待',
  // brushless_idr_acc_3_name: '冲击起子头套装',
  // brushless_idr_acc_3_desc: '25 支冲击级起子头套装，涵盖十字、梅花、一字和六角多种规格，钢材硬度高于标准起子头',
  // brushless_idr_acc_4_name: '磁性起子头延长杆',
  // brushless_idr_acc_4_desc: '60/150 mm 磁性六角延长杆，触达狭窄空间内的紧固件，磁力定位防止起子头掉落',
  // brushless_idr_acc_5_name: '螺套工具收纳包',
  // brushless_idr_acc_5_desc: '帆布工具包，分格收纳冲击起子机、电池和起子头，轻便携带适合多工地转场',
  // brushless_idr_acc_6_name: '防割工作手套',
  // brushless_idr_acc_6_desc: '耐磨高强力工作手套，在密集紧固作业中保护双手，同时保持对冲击起子机的扳机感知',
  // brushless_idr_acc_7_name: '腰带工具夹',
  // brushless_idr_acc_7_desc: '坚固工具腰带夹，方便随手取放冲击起子机，双手空闲时不必来回走动取工具',
  // brushless_idr_acc_8_name: '起子头架套装',
  // brushless_idr_acc_8_desc: '磁性起子头架，可同时插放多支常用起子头，现场快速换头无需逐一从包里取找',

  // 无刷角磨机系列配件（ag 类，共用）
  // brushless_ag_acc_1_name: '20V 4Ah 锂电池',
  // brushless_ag_acc_1_desc: '大容量 20V 4Ah 锂电池，满足连续金属研磨和切割高耗能需求，减少中途换电次数',
  // brushless_ag_acc_2_name: '快充充电器',
  // brushless_ag_acc_2_desc: '55 分钟急速充电，角磨机长时间研磨作业中短暂休息即可补满电量继续工作',
  // brushless_ag_acc_3_name: '金属研磨片套装',
  // brushless_ag_acc_3_desc: '5 片 125 mm 氧化铝研磨片套装，36/60/80 目可选，焊缝研磨、锈迹处理和金属整形一包搞定',
  // brushless_ag_acc_4_name: '金刚石切割片',
  // brushless_ag_acc_4_desc: '125 mm 干湿两用金刚石切割片，混凝土、砖块、瓷砖切割边缘整洁，寿命远超普通砂轮',
  // brushless_ag_acc_5_name: '安全防护面罩',
  // brushless_ag_acc_5_desc: '全面部透明防护面罩，防御研磨和切割作业时的金属碎屑和火花飞溅，配合护目镜使用',
  // brushless_ag_acc_6_name: '防振工作手套',
  // brushless_ag_acc_6_desc: '硅胶防振掌面工作手套，减少研磨作业长时间振动传导，保护手关节并改善握持舒适度',
  // brushless_ag_acc_7_name: '砂轮更换法兰套件',
  // brushless_ag_acc_7_desc: '砂轮更换专用内外法兰套件及销钉扳手，配件完整，安全可靠地更换研磨片和切割片',
  // brushless_ag_acc_8_name: '工具收纳包',
  // brushless_ag_acc_8_desc: '耐用帆布工具包，角磨机、电池和常用磨片一同收纳，防尘防磕碰，施工现场随取随用',
  A: '中文型号',
  B: '我是电池',
};

export default brushlessFeaturesZh;
